import Vue from 'vue';

import config from '../config';
import menu from '../config/menu';

/**
 * 无权限时，页面展示
 */
function showNoRole () {
  const mainDom = document.querySelectorAll('.global-layout');
  mainDom[0].innerHTML = '';
}

/**
 * 需求登录
 */
function needLogin (obj = {}) {
  console.log('=====> needLogin');
  Vue.prototype.$showLoading('需要登录访问，稍后跳转登录...');

  setTimeout(() => {
    Vue.prototype.$hideLoading();
    obj.callback && obj.callback();
    redirectToLogin();
  }, 1000);
}

/**
 * 权限需求不一致
 */
function needRole (obj = {}) {
  showNoRole();
  Vue.prototype.$msgbox({
    title: '无权访问',
    // msg: `您无权访问该页面，请登录对应的账户后访问，错误码：${obj.errcode}，错误信息：${obj.errmsg}`,
    message: `您无权访问该页面，请登录对应的账户后访问`,
    confirmButtonText: '我知道了',
    callback (action) {
      if (action === 'confirm') {
        obj.callback && obj.callback();
      }
    },
  });
}

/**
 * 需求管理员权限
 */
function needAdmin (obj = {}) {
  console.log('=====> obj', obj);
  showNoRole();
  Vue.prototype.$msgbox({
    title: '无权访问',
    message: '您无权访问该页面，有问题请联系站点管理员',
    confirmButtonText: '我知道了',
    callback (action) {
      if (action === 'confirm' && obj.callback && typeof obj.callback ===
        'function') {
        obj.callback();
      }
    },
  });
}

function needMpAuth (appid) {
  Vue.prototype.$msgbox({
    type: 'confirm',
    message: `您的小程序还未授权`,
    title: `提示`,
    showClose: false,
    confirmButtonText: '去授权',
    callback (action) {
      if (action === 'confirm') {
        window.open(
          `https://api.govcloud.qq.com/static/start_auth.html?appid=${appid}&time=${+new Date()}&authCallBackUri=${encodeURIComponent(
            window.location.href)}`);
        window.history.back();
      }
    },
  });
}

/**
 * 重定向到登录页
 */
function redirectToLogin () {
  // eslint-disable-next-line no-undef
  if (config.hostType === 'open') {
    window.location.href = menu.manage.url;
  }
}

function redirectToLogout () {
  window.location.href = config.logout;
}

function errorMsg (msg) {
  Vue.prototype.$toast.error(msg);
}

export {
  showNoRole,
  redirectToLogin,
  redirectToLogout,
  needLogin,
  needRole,
  needAdmin,
  needMpAuth,
  errorMsg,
};
